import { render, staticRenderFns } from "./TheChallengeView.vue?vue&type=template&id=4e19b04e&scoped=true&"
import script from "./TheChallengeView.vue?vue&type=script&lang=js&"
export * from "./TheChallengeView.vue?vue&type=script&lang=js&"
import style0 from "./TheChallengeView.vue?vue&type=style&index=0&id=4e19b04e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19b04e",
  null
  
)

export default component.exports